import Storage from './Storage'
import UUID from 'uuid/v4'

import ActionTemplate from './ActionTemplates'

class Workflow extends Storage.Vue {

  static get name() {
    return 'workflows'
  }

  constructor(attributes) {

    if (!attributes.actions) {
      attributes.actions = []
    }
    if (!attributes.tags) {
      attributes.tags = []
    }
    attributes.isLoading = false

    if (!attributes.plainActions) {
      attributes.plainActions = attributes.actions
    }

    if (!attributes.output) {
      attributes.output = {}
    }
    if (!attributes.linkedActionUuid) {
      attributes.linkedActionUuid = null
    }

    delete attributes.actions

    return super({
      data: attributes,
      computed: {

        actions: {
          get() {
            return this.plainActions.map((action) => {
              action.template = function(){
                if (!this._template && this.template_id) {
                  this._template = ActionTemplate.storage.find(this.template_id)
                }
                return this._template
              }
              if (!action.static_params) {
                action.static_params = {}
              }

              action.requiredInputs = function(){
                if (this._requiredInputs) {
                  return this._requiredInputs
                }
                if (this.template().method == 'SelectWorkflow') {
                  return []
                }
                let template = ActionTemplate.storage.find(this.template_id)
                let providedKeys = Object.keys(this.input_mapping)
                let providedByStaticParams = Object.keys(this.static_params).filter((key) => {
                  return !!this.static_params[key]
                })
                providedKeys.push(...providedByStaticParams)

                let requiredKeys = Object.keys(this.template().input)
                requiredKeys.push(...this.template().pathParams)

                this._requiredInputs = _.difference(requiredKeys, providedKeys).map((name)=>{
                  return {
                    action: {
                      name: this.name,
                      uuid: this.uuid
                    },
                    name: name
                  }
                })
                return this._requiredInputs
              }

              return action
            })
          },
          set(data) {
            this.plainActions = data
          }
        },

        input() {
          return this.actions.map((action) => {
            return action.requiredInputs()
          }).flat()
        },

        searchContent() {
          return [
            this.tags,
            this.name,
            this.actions.map(action => action.name)
          ].flat().join(" ").toLowerCase()
        }
      },

      methods: {

        asJson() {
          let json = Object.assign({}, this.$data)
          json.plainActions = json.plainActions.map((action)=>{
            let plainAction = Object.assign({}, action)
            delete plainAction._template
            delete plainAction.template
            return Object.assign({}, plainAction)
          })
          return json
        },

        save() {
          if (Object.keys(this.output).length > 0) {

            let template
            if (this.linkedActionUuid) {
              template = ActionTemplate.storage.find(this.linkedActionUuid)
            }
            if (!template) {
              template = new ActionTemplate({method: 'SelectWorkflow', uuid: UUID(), name: "Select previous workflow", input_mapping: {}, static_params: {}, input: {}, output: {}, workflowUuid: this.uuid})
            }
            template.output = {}
            for (let [key, outputObject] of Object.entries(this.output)) {
              template.output[outputObject.name] = `workflow.${outputObject.name}`
            }
            template.save()
            this.linkedActionUuid = template.uuid
          }

          this.storage.save(Object.assign({}, this.asJson()))
        },

        requiredTemplates() {
          let allTemplates = ActionTemplate.storage.allPlainGrouped()
          return this.actions.map((action)=>{
            return allTemplates[action.template_id]
          })
        },

        availableOutputs(actionIndex = -1) {
          let allTemplates = ActionTemplate.storage.allGrouped()


          let actionSubset
          if (actionIndex < 0) {
            actionSubset = this.actions
          } else {
            actionSubset = this.actions.slice(0, actionIndex)
          }

          return actionSubset.map((action) => {
            let template = allTemplates[action.template_id]
            return Object.keys(template.output).map((outputName)=>{
              return {
                action: action,
                output: outputName
              }
            })
          }).flat().map((availableOutput)=>{
            availableOutput.id = [availableOutput.action.uuid, availableOutput.output].join('_')
            return availableOutput
          })
        }
      }
    })
  }

}

window.Workflow = Workflow

export default Workflow